/* tslint:disable */
/* eslint-disable */
export enum WorkDocumenttypeIdentifierNameEnum {
  AllgemeinesDokumentOhneWorkflow = 'AllgemeinesDokumentOhneWorkflow',
  Empty = 'Empty',
  Betriebsmitteldokument = 'Betriebsmitteldokument',
  Mitarbeiterdokument = 'Mitarbeiterdokument',
  MitarbeiterProfilbild = 'MitarbeiterProfilbild',
  Projektfoto = 'Projektfoto',
  ProjektTitelbild = 'ProjektTitelbild',
  Screendokument = 'Screendokument',
  Ticketdokument = 'Ticketdokument',
  Produktbild = 'Produktbild',
  SelfserviceDokument = 'SelfserviceDokument',
  Kreditor = 'Kreditor',
  Artikeldokument = 'Artikeldokument',
  Kontaktbild = 'Kontaktbild',
  Energieversorgerdokument = 'Energieversorgerdokument',
  InternesDokument = 'InternesDokument',
  Spesenbeleg = 'Spesenbeleg',
  ChatAnhang = 'ChatAnhang'
}
